const BASE_PATH = "app/admin/dashboard/";

export const SET_HOME = `${BASE_PATH}set-home`;
